import { CleanoutMethodBase } from './base/cleanout-method-base';

export class CleanoutMethod extends CleanoutMethodBase { }